import publicCta from '../content/publicCta.json';

/** Solo dígitos, con indicativo de país (Colombia: 57…). */
function normalizePhone(raw) {
  return String(raw || '').replace(/\D/g, '');
}

const phoneRaw =
  import.meta.env.VITE_WHATSAPP_PHONE?.trim() || String(publicCta.whatsappPhone || '').trim() || '573001234567';

export const WHATSAPP_PHONE = normalizePhone(phoneRaw);

/** Formato legible para Colombia (+57 3xx xxx xxxx). */
export function formatPhoneDisplay(phone = WHATSAPP_PHONE) {
  const digits = normalizePhone(phone);
  if (!digits) return '';
  if (digits.startsWith('57') && digits.length === 12) {
    const local = digits.slice(2);
    return `+57 ${local.slice(0, 3)} ${local.slice(3, 6)} ${local.slice(6)}`;
  }
  return `+${digits}`;
}

export function getTelHref(phone = WHATSAPP_PHONE) {
  const digits = normalizePhone(phone);
  return digits ? `tel:+${digits}` : '';
}

export const WHATSAPP_DEFAULT_MESSAGE =
  import.meta.env.VITE_WHATSAPP_MESSAGE?.trim() ||
  String(publicCta.whatsappMessage || '').trim() ||
  'Hola, quiero información sobre Coonaltragas.';

export function getWhatsAppUrl(message = WHATSAPP_DEFAULT_MESSAGE) {
  if (!WHATSAPP_PHONE) return '';
  const text = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${WHATSAPP_PHONE}${text}`;
}

/** wa.me para un celular colombiano (10 dígitos o con prefijo 57). */
export function getWhatsAppUrlForPhone(phone, message = WHATSAPP_DEFAULT_MESSAGE) {
  let digits = normalizePhone(phone);
  if (!digits) return '';
  if (digits.length === 10 && digits.startsWith('3')) {
    digits = `57${digits}`;
  } else if (!digits.startsWith('57') && digits.length >= 10) {
    digits = `57${digits}`;
  }
  const text = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${digits}${text}`;
}

/** Opciones del menú flotante de WhatsApp. */
export const WHATSAPP_TOPICS = Array.isArray(publicCta.whatsappTopics)
  ? publicCta.whatsappTopics.filter((t) => t?.label && t?.message)
  : [];
